module.exports = __webpack_public_path__ + "static/img/map__currentlocation_marker.b498dcfc.png";